import React, { useEffect, useMemo, useState} from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  Typography,
  TextField,
  MenuItem,
  InputAdornment,
  Card,
  Dialog,
  DialogActions, DialogContent, DialogTitle, CardContent,
  alpha,
  Chip,
} from "@mui/material";
import { FaMoneyBillWave, FaPlusCircle ,FaFileAlt, FaClipboardList , FaChartPie , FaCog , FaMoneyCheckAlt, FaChartBar } from 'react-icons/fa'; // Example icons

import { useNotifier } from "../../../Core/Notifier";
import { useStyles } from "../../../theme/appStyles";
import { useNavigate } from "react-router-dom";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import Pagination from "../../../Components/Pagination";
import axios from "axios";
import PrintIcon from "@mui/icons-material/Print";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import * as XLSX from "xlsx";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DescriptionIcon from '@mui/icons-material/Description';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CommentIcon from '@mui/icons-material/Comment';
import { Tooltip as MuiTooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import LoopIcon from '@mui/icons-material/Loop';           // Circular arrow, used for Before
import LoopOutlinedIcon from '@mui/icons-material/LoopOutlined'; // Outlined circular arrow, used for After
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import dayjs, { Dayjs } from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";


ChartJS.register(ArcElement, Tooltip, Legend);

interface Expense {
  id: number;
  date: string;
  description: string;
  remarks: string;
  amount: number;
  hst: number;
  category: string | number;
  status: string;
  total: number;
  type?: string;
  file?: string;
  created_at: string;
  before_images?: string;
  after_images?: string;
}

interface Category {
  id: number;
  category_name: string;
}

interface Driver {
  id: number;
  driverFirstName: string;
  driverLastName: string;
  driverUserRole: string;
}

interface Deposit {
  id: number;
  amount: string;
  user_id: number;
  created_at: string;
  date: string;
  is_approved: boolean;
  remarks: string;
}

interface UserInfo {
  id: number;
  username: string;
  token: string;
  user_id: number;
}


const BRAND = "#2f3891";
const SUCCESS = "#22c55e";
const WARN = "#f59e0b";
const DANGER = "#ef4444";
const BG = "#f1f5f9";
const BORDER = "#e2e8f0";

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [expenses, setExpenses] = useState<Expense[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [team, setTeam] = useState<Driver[]>([]);
  const [deposit, setDeposit] = useState<Deposit[]>([]);
  const { showErrorMessage, showMessage } = useNotifier();
  const API_URL = process.env.REACT_APP_API_URL;
  const [searchQuery, setSearchQuery] = useState("");
  const [filterCategory, setFilterCategory] = useState<number | "">("");
  const [filterType, setFilterType] = useState("");
  const [filterDateFrom, setFilterDateFrom] = useState("");
  const [filterDateTo, setFilterDateTo] = useState("");
  const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(50);
const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
const [pdfLoading, setPdfLoading] = useState(false);
const [openModal, setOpenModal] = useState(false);
const [openModalView, setOpenModalView] = useState(false);
const [fileUrl, setFileUrl] = useState<string | null>(null);
const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
const [tooltipOpen, setTooltipOpen] = React.useState<Record<number, boolean>>({});
const [showImages, setShowImages] = useState(false);
const [beforeImages, setBeforeImages] = useState<string[]>([]);
const [afterImages, setAfterImages] = useState<string[]>([]);
const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
const [deleteTargetId, setDeleteTargetId] = useState<number | null>(null);
const isPdf = fileUrl?.endsWith('.pdf');


const handleViewImages = (beforeImagesData: string[], afterImagesData: string[]) => {
  console.log("Before Images Data:", beforeImagesData);  // This should now show the images
  setBeforeImages(beforeImagesData || []);
  setAfterImages(afterImagesData || []);
  setOpenModalView(true);
};


 // Handle tooltip open for desktop (hover) and mobile (tap)
 const handleTooltipOpen = (id: number) => {
  if (window.innerWidth > 768) {
    setTooltipOpen((prev) => ({ ...prev, [id]: true })); // Open tooltip on hover for desktop
  }
};

const handleTooltipClose = (id: number) => {
  if (window.innerWidth > 768) {
    setTooltipOpen((prev) => ({ ...prev, [id]: false })); // Close tooltip on hover leave for desktop
  }
};

// Handle touch on mobile
const handleMobileTooltipToggle = (id: number) => {
  if (window.innerWidth <= 768) {
    setTooltipOpen((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle the open state for the specific tooltip
    })); // Toggle open/close on tap for mobile
  }
};

const categoryMap = useMemo(
  () =>
    categories.reduce((map, category) => {
      map[String(category.id)] = category.category_name;
      return map;
    }, {} as Record<string, string>),
  [categories]
);

  const filteredExpenses = expenses.filter((expense) => {
    const matchesSearch =
      expense.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (categoryMap[expense.category] || "").toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = filterCategory === "" || String(expense.category) === String(filterCategory);
    const matchesType = filterType === "" || (expense.type ?? "") === filterType;
    const matchesFrom = filterDateFrom === "" || expense.date >= filterDateFrom;
    const matchesTo = filterDateTo === "" || expense.date <= filterDateTo;
    return matchesSearch && matchesCategory && matchesType && matchesFrom && matchesTo;
  });

const totalHst = filteredExpenses.reduce((sum, expense) =>  {
  return sum + (Number(expense.hst) || 0);
}, 0);

const totalAmount = filteredExpenses.reduce((sum, expense) => {
  return sum + (Number(expense.amount) || 0);
}, 0);

const totalAmountWithTax = filteredExpenses.reduce((sum, expense) => {
  return sum + (Number(expense.total) || 0);
}, 0);



  const handleEditClick = (id: number) => {
    navigate(`/expense/${id}`);
  };

  const handleDeleteClick = (id: number) => {
    // Delete expense logic
    axios.delete(`${API_URL}/delete-expense/${id}`).then(() => {
      setExpenses(expenses.filter((expense) => expense.id !== id));
      showMessage("Deleted successfully");
    }).catch((error) => {
     // console.error("Failed to delete expense", error);
      showErrorMessage("Failed to delete the template");
    });
  };



  useEffect(() => {
    const fetchExpenses = async () => {
      try {
        const response = await axios.get(`${API_URL}/view-expenses`);
        setExpenses(response.data); // Set the fetched data to state


      } catch (error) {
        console.error("Failed to load expenses", error);
      }
    };
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${API_URL}/view-expense-category`);
        setCategories(response.data);
        //console.log(response.data);
      } catch (error) {
        console.error("Failed to load categories", error);
      }
    };
    const fetchTeam = async () => {
      try {
        const response = await axios.get(`${API_URL}/view-team`);
        // setTeam(response.data.data);
        const team: Driver[] = response.data.data;
        const managers = team.filter(driver => driver.driverUserRole === 'manager');
        setTeam(managers);
       // console.log(response.data.data);
      } catch (error) {
        console.error("Failed to load team members", error);
      }
    };

    const fetchDeposit = async () => {
      try {
        const response = await axios.get(`${API_URL}/view-deposit`);
        setDeposit(response.data); // Set the fetched data to state
        // console.log(response.data);
      } catch (error) {
        console.error("Failed to load expenses", error);
      }
    };

    const fetchUserInfo = async () => {
      try {
          const response = await axios.post(
              `${API_URL}/user/userInfo`,
              {}, // No body required
              {
                  headers: {
                      'Content-Type': 'application/json',
                      Authorization: `Bearer ${localStorage.getItem('token') || ''}`, // Include token from localStorage
                  },
              }
          );
          setUserInfo(response.data.data); // Update your state with the response
        console.log(response.data.data)
      } catch (error) {
          console.error('Error fetching user info', error);
      }
  };

    fetchExpenses();
    fetchCategories();
    fetchTeam();
    fetchDeposit();
    fetchUserInfo();
  }, [API_URL]);


  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const generateYearlyData = (expenses: Expense[]) => {
    const yearlyData = Array(12).fill(0); // Array to store expenses for each month (12 months)

    expenses.forEach((expense) => {
      const expenseDate = new Date(expense.date);
      const month = expenseDate.getMonth(); // Get month (0-11)

      // Ensure expense.total is a number
      let totalExpense = expense.total;

      if (typeof totalExpense === 'string') {
        totalExpense = parseFloat(totalExpense); // Convert string to number
      }

      // Check if totalExpense is a valid number
      if (!isNaN(totalExpense)) {
        yearlyData[month] += totalExpense; // Aggregate expense by month
      } else {
        console.error("Invalid total expense:", expense.total); // Log invalid total
      }
    });

    // Ensure that no NaN values are in yearlyData
    const validYearlyData = yearlyData.map((value) => (isNaN(value) ? 0 : value)); // Replace NaN with 0

    //console.log(validYearlyData); // Check the data
    return validYearlyData;
  };


  const generateCategoryData = (expenses: Expense[], categories: Category[]) => {
    const categoryTotals: Record<string, number> = {};

    // Map category ID to category name
    const categoryMap = categories.reduce((acc, category) => {
      acc[String(category.id)] = category.category_name;
      return acc;
    }, {} as Record<string, string>);

    expenses.forEach((expense) => {
      let totalExpense = expense.total;

      // Ensure totalExpense is a number
      if (typeof totalExpense === 'string') {
        totalExpense = parseFloat(totalExpense); // Convert string to number
      }

      // Get the category name using the category ID
      const categoryName = categoryMap[String(expense.category)];

      if (categoryName) {
        //console.log(`Processing Category: ${categoryName}, Total Expense: ${totalExpense}`);

        // Check if totalExpense is a valid number
        if (!isNaN(totalExpense)) {
          if (!categoryTotals[categoryName]) {
            categoryTotals[categoryName] = 0;
          }
          categoryTotals[categoryName] += totalExpense; // Aggregate by category name
        } else {
          console.error("Invalid category total:", expense.total);
        }
      } else {
        console.error("Invalid category ID:", expense.category);
      }
    });

    // Ensure that no NaN values are in categoryTotals
    const validCategoryTotals = Object.fromEntries(
      Object.entries(categoryTotals).map(([key, value]) => [key, isNaN(value) ? 0 : value])
    );

    //console.log('Final Category Totals:', validCategoryTotals);
    return validCategoryTotals;
  };




  const categoryData = generateCategoryData(expenses, categories);
  const yearlyData = generateYearlyData(expenses);


  const handleAddProductClick = () => {
    navigate("/expense/create");
  };

  const handleDownloadPdf = async () => {
    setPdfLoading(true);
    try {
      const params: Record<string, string> = {};
      if (searchQuery.trim()) params.search = searchQuery.trim();
      if (filterCategory !== "") params.category = String(filterCategory);
      if (filterType) params.type = filterType;
      if (filterDateFrom) params.start_date = filterDateFrom;
      if (filterDateTo) params.end_date = filterDateTo;
      const response = await axios.get(`${API_URL}/pdf/expense-report`, {
        params, responseType: "blob",
        headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` },
      });
      const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
      window.open(url, "_blank");
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `expense-report-${new Date().toISOString().slice(0, 10)}.pdf`);
      document.body.appendChild(link); link.click(); link.remove();
      setTimeout(() => window.URL.revokeObjectURL(url), 10000);
    } catch { /* silent */ } finally { setPdfLoading(false); }
  };

  const handleExportToExcel = () => {
    const data = filteredExpenses.map((exp, i) => ({
      "#":          i + 1,
      "Date":       exp.date || "",
      "Details":    exp.description || "",
      "Remarks":    exp.remarks || "",
      "Category":   categoryMap[exp.category] || String(exp.category),
      "Type":       exp.type || "",
      "Amount":     Number(exp.amount || 0).toFixed(2),
      "HST":        Number(exp.hst || 0).toFixed(2),
      "Total":      Number(exp.total || 0).toFixed(2),
      "Status":     String(exp.status),
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    ws["!cols"] = Object.keys(data[0] || {}).map((k) => ({
      wch: Math.max(k.length, ...data.map((r: any) => String(r[k] || "").length)) + 2,
    }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Expenses");
    XLSX.writeFile(wb, `expenses_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  const handleAddCategoryClick = () => {
    navigate("/expense-category/list");
  };

  const chartData = [
    { name: "Total HST", y: totalHst },
    { name: "Total Amount (Without hst)", y: totalAmount },
    // { name: "Total Amount (with hst)", y: totalAmountWithTax }
  ];

  // Highcharts options
  const chartOptions = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "pie",
      height: 350,
      width: 250,
    },
    title: {
      text: " ",
      align: "left",
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
        innerSize: "40%",
      },
    },
    legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "top",
      symbolRadius: 0,
      itemStyle: {
        fontWeight: "normal",
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: 'Expenses',
        colorByPoint: true,
        data: chartData, // Data for the three totals
      },
    ],
  };

  const parseFiles = (file: string | undefined): string[] => {
    try {
      return file ? JSON.parse(file) : [];
    } catch (error) {
      return [];
    }
  };
  // Function to handle opening the modal
  const handleOpenModal = (file: string): void => {
    const url = `${LARAVEL_API_URL}/${file}`;
    setFileUrl(url);
    setOpenModal(true);
  };

  // Function to handle closing the modal
  const handleCloseModal = () => {
    setOpenModal(false);
    setFileUrl(null);
  };

  const handleCloseModalView = () => {
    setOpenModalView(false);
   // setFileUrl(null);
  };

  const handleDepositClick = (id: any) => {
    // console.log(`${id} Deposit Clicked`);
   // navigate("/deposit/create");
    navigate("/deposit/create", { state: { userId: id } });
  };


  const lineChartOptions = {
    chart: {
      type: 'line',
      height: 350,
      // width: 500,
    },
    title: {
      text: 'Yearly Expense Trend',
    },
    xAxis: {
      categories: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      ],
    },
    yAxis: {
      title: {
        text: 'Expense Amount ($)',
      },
    },
    credits: {
      enabled: false, // Disable the watermark
    },
    series: [
      {
        name: 'Total Expense',
        data: yearlyData,
      },
    ],

  };

  // Bar Chart (Expense Category)
  const barChartOptions = {
    chart: {
      type: 'column',
      height: 350,
      // width: 500,
    },
    title: {
      text: 'Expense by Category',
    },
    xAxis: {
      categories: categories.map((category) => category.category_name), // Category names
    },
    yAxis: {
      title: {
        text: 'Expense Amount ($)',
      },
    },
    credits: {
      enabled: false, // Disable the watermark
    },
    series: [
      {
        name: 'Expense',
        data: categories.map((category) => categoryData[category.category_name] || 0), // Ensure the data is mapped correctly to the categories
      },
    ],
  };


 const calculateCategoryHST = (expenses: Expense[], categories: Category[]) => {
  const categoryHST: Record<string, number> = {};

  const categoryMap = categories.reduce((acc, category) => {
    acc[String(category.id)] = category.category_name;
    return acc;
  }, {} as Record<string, string>);

  expenses.forEach((expense) => {
    const hst = Number(expense.hst) || 0; // Use the existing value or default to 0
    const categoryName = categoryMap[String(expense.category)];

    if (categoryName) {
      categoryHST[categoryName] = (categoryHST[categoryName] || 0) + hst;
    }
  });

  return categoryHST;
};

// Example Usage
const categoryHST = calculateCategoryHST(expenses, categories);
const totalBankBalance = deposit.filter((d) => d.is_approved).reduce((acc, curr) => acc + Number(curr.amount), 0);
const overallExpense = expenses.reduce((acc, expense) => acc + Number(expense.total), 0);
const paidExpense =  expenses
.filter(expense => String(expense.status) === 'Paid')  // Convert status to string
.reduce((total, expense) => total + expense.amount, 0);


const calculatePieData = (categoryName: string) => {
  const totalExpense = categoryData[categoryName] || 0;
  const totalHST = categoryHST[categoryName] || 0;
  const overallExpensePercentage = ((totalExpense / overallExpense) * 100).toFixed(2);

  return {
    labels: [`${categoryName} %`, `Overall Expense`],
    datasets: [
      {
        data: [totalExpense, overallExpense], // Data for percentage and total expense
        backgroundColor: ['#4CAF50', '#FF9800'], // Green for percentage, Orange for overall expense
        hoverOffset: 4,
      },
    ],
  };
};


const handleApproveDeposit = (depositId: number) => {
  // API call to approve the deposit (you can use Axios or Fetch)
  axios
    .put(`${API_URL}/deposits/${depositId}/approve`,   { approved_by: userInfo?.user_id } )
    .then((response) => {
      showMessage("Approved successfully");
      // Update the state to reflect the change (this will re-render the UI)
      setDeposit((prevDeposits) =>
        prevDeposits.map((deposit) =>
          deposit.id === depositId ? { ...deposit, is_approved: true } : deposit
        )
      );
    })
    .catch((error) => {
      console.error('Error approving deposit:', error);
    });
};

const calculatePaidExpenses = () => {
  return expenses
    .filter(expense => String(expense.status) === 'Paid') // Ensure status is a string and matches "Paid"
    .reduce((total, expense) => {
      // Check if the amount is a string and parse it to a number if necessary
      const amount = typeof expense.amount === 'string' ? parseFloat(expense.amount) : expense.amount;
      return total + (isNaN(amount) ? 0 : amount); // If amount is not a valid number, treat it as 0
    }, 0);
};


const formatCurrency = (amount: number) => {
  return amount.toFixed(2); // Format the number to two decimal places
};

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, bgcolor: "#f8fafc", minHeight: "100vh" }}>
      {/* ── Page Header ── */}
      <Box sx={{
        background: "linear-gradient(135deg,#2f3891 0%,#2f3891 100%)",
        borderRadius: 3, px: 3, py: 2.5, mb: 3,
        display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1.5,
      }}>
        <Box>
          <Typography sx={{ color: "#fff", fontWeight: 800, fontSize: 18 }}>Manage Expenses</Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.7)", fontSize: 12, mt: 0.3 }}>
            {filteredExpenses.length} expense{filteredExpenses.length !== 1 ? "s" : ""} found
          </Typography>
        </Box>
        <Button
          variant="contained"
          size="small"
          onClick={handleAddProductClick}
          sx={{ bgcolor: "rgba(255,255,255,0.2)", color: "#fff", textTransform: "none", fontWeight: 700, fontSize: 12, "&:hover": { bgcolor: "rgba(255,255,255,0.3)" } }}
        >
          + Add Expense
        </Button>
      </Box>

      {/* ── Filter Bar ── */}
      <Box sx={{ bgcolor: "#fff", borderRadius: 3, border: `1px solid ${BORDER}`, p: 2.5, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              select
              label="Category"
              size="small"
              fullWidth
              value={filterCategory}
              onChange={(e) => setFilterCategory(e.target.value === "" ? "" : Number(e.target.value))}
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
            >
              <MenuItem value="">All Categories</MenuItem>
              {categories.map((c) => (
                <MenuItem key={c.id} value={c.id}>{c.category_name}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              select
              label="Type"
              size="small"
              fullWidth
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
            >
              <MenuItem value="">All Types</MenuItem>
              {["Other", "Labour", "Material", "Material+Labour"].map((t) => (
                <MenuItem key={t} value={t}>{t}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <DatePicker
              views={["day"]}
              openTo="day"
              label="From"
              value={filterDateFrom ? dayjs(filterDateFrom) : null}
              onChange={(val: Dayjs | null) => setFilterDateFrom(val && val.isValid() ? val.format("YYYY-MM-DD") : "")}
              format="MMM DD, YYYY"
              slotProps={{
                textField: { size: "small", fullWidth: true, placeholder: "Select date",
                  sx: { "& .MuiOutlinedInput-root": { borderRadius: 2.5, bgcolor: "#f9fafb", fontSize: 13, height: 40 } } },
                popper: { sx: {
                  "& .MuiPaper-root": { borderRadius: 3, boxShadow: "0 12px 40px rgba(0,0,0,0.12)", border: "1px solid #e2e8f0" },
                  "& .MuiPickersDay-root.Mui-selected": { bgcolor: "#2f3891 !important", fontWeight: 700 },
                  "& .MuiPickersDay-root:hover": { bgcolor: "#eef2ff" },
                  "& .MuiPickersDay-root": { borderRadius: 2, fontWeight: 500 },
                  "& .MuiPickersCalendarHeader-label": { fontWeight: 700, fontSize: 14, color: "#1e293b", pointerEvents: "none" },
                  "& .MuiPickersArrowSwitcher-button": { borderRadius: 1.5 },
                }},
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <DatePicker
              views={["day"]}
              openTo="day"
              label="To"
              value={filterDateTo ? dayjs(filterDateTo) : null}
              onChange={(val: Dayjs | null) => setFilterDateTo(val && val.isValid() ? val.format("YYYY-MM-DD") : "")}
              format="MMM DD, YYYY"
              slotProps={{
                textField: { size: "small", fullWidth: true, placeholder: "Select date",
                  sx: { "& .MuiOutlinedInput-root": { borderRadius: 2.5, bgcolor: "#f9fafb", fontSize: 13, height: 40 } } },
                popper: { sx: {
                  "& .MuiPaper-root": { borderRadius: 3, boxShadow: "0 12px 40px rgba(0,0,0,0.12)", border: "1px solid #e2e8f0" },
                  "& .MuiPickersDay-root.Mui-selected": { bgcolor: "#2f3891 !important", fontWeight: 700 },
                  "& .MuiPickersDay-root:hover": { bgcolor: "#eef2ff" },
                  "& .MuiPickersDay-root": { borderRadius: 2, fontWeight: 500 },
                  "& .MuiPickersCalendarHeader-label": { fontWeight: 700, fontSize: 14, color: "#1e293b", pointerEvents: "none" },
                  "& .MuiPickersArrowSwitcher-button": { borderRadius: 1.5 },
                }},
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              size="small"
              fullWidth
              placeholder="Search description, category..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CiSearch style={{ color: "#94a3b8" }} />
                  </InputAdornment>
                ),
                sx: { borderRadius: 1.5 },
              }}
            />
          </Grid>
        </Grid>
        {(filterCategory !== "" || filterType !== "" || filterDateFrom !== "" || filterDateTo !== "" || searchQuery !== "") && (
          <Box sx={{ mt: 1.5, display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
            <Typography sx={{ fontSize: 11, color: "#94a3b8", mr: 0.5 }}>Active filters:</Typography>
            {filterCategory !== "" && (
              <Chip size="small" label={`Category: ${categoryMap[String(filterCategory)]}`} onDelete={() => setFilterCategory("")} sx={{ fontSize: 11 }} />
            )}
            {filterType !== "" && (
              <Chip size="small" label={`Type: ${filterType}`} onDelete={() => setFilterType("")} sx={{ fontSize: 11 }} />
            )}
            {filterDateFrom !== "" && (
              <Chip size="small" label={`From: ${filterDateFrom}`} onDelete={() => setFilterDateFrom("")} sx={{ fontSize: 11 }} />
            )}
            {filterDateTo !== "" && (
              <Chip size="small" label={`To: ${filterDateTo}`} onDelete={() => setFilterDateTo("")} sx={{ fontSize: 11 }} />
            )}
            {searchQuery !== "" && (
              <Chip size="small" label={`Search: ${searchQuery}`} onDelete={() => setSearchQuery("")} sx={{ fontSize: 11 }} />
            )}
          </Box>
        )}
      </Box>

      {/* ── Main Expense Table Card ── */}
      <Box sx={{ bgcolor: "#fff", borderRadius: 3, border: `1px solid ${BORDER}`, overflow: "hidden", mb: 3 }}>
        {/* Card header */}
        <Box sx={{ px: 3, py: 2, borderBottom: `1px solid ${BORDER}`, display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box sx={{ width: 8, height: 8, borderRadius: "50%", background: BRAND, flexShrink: 0 }} />
          <Typography sx={{ fontWeight: 700, fontSize: 14, color: "#0f172a" }}>Expenses</Typography>
          <Chip
            label={`${filteredExpenses.length} records`}
            size="small"
            sx={{ background: alpha(BRAND, 0.1), color: BRAND, fontWeight: 700, fontSize: 11 }}
          />
          <Box sx={{ flex: 1 }} />
          <Button size="small" variant="outlined"
            startIcon={pdfLoading ? <CircularProgress size={13} color="inherit" /> : <PrintIcon sx={{ fontSize: 15 }} />}
            onClick={handleDownloadPdf} disabled={pdfLoading}
            sx={{ mr: 1, borderRadius: 1.5, textTransform: "none", fontSize: 12, color: "#64748b", borderColor: "#e2e8f0" }}>
            {pdfLoading ? "Generating…" : "Print"}
          </Button>
          {filteredExpenses.length > 0 && (
            <Button size="small" variant="outlined"
              startIcon={<TableChartOutlinedIcon sx={{ fontSize: 15 }} />}
              onClick={handleExportToExcel}
              sx={{ mr: 1, borderRadius: 1.5, textTransform: "none", fontSize: 12, color: "#16a34a", borderColor: "#e2e8f0" }}>
              Excel
            </Button>
          )}
          <Button
            variant="contained"
            size="small"
            onClick={handleAddProductClick}
            sx={{
              background: `linear-gradient(135deg, ${BRAND} 0%, #818cf8 100%)`,
              boxShadow: "none", borderRadius: 1.5, fontWeight: 700, textTransform: "none", fontSize: 13,
              "&:hover": { boxShadow: `0 4px 14px ${alpha(BRAND, 0.4)}` },
            }}
          >
            + Add Expense
          </Button>
        </Box>

        {/* Table */}
        <TableContainer sx={{ maxHeight: 520 }} className={classes.thinScrollbar}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {["Date", "Details", "Category", "Type", "Amount", "HST", "Total", "Status", "Actions"].map((h) => (
                  <TableCell
                    key={h}
                    sx={{
                      background: "#f8fafc",
                      fontWeight: 700,
                      fontSize: 11,
                      textTransform: "uppercase",
                      color: "#64748b",
                      letterSpacing: 0.5,
                      borderBottom: `2px solid ${BORDER}`,
                      whiteSpace: "nowrap",
                      ...(h === "Actions" ? { textAlign: "right" } : {}),
                    }}
                  >
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredExpenses.length > 0 ? (
                filteredExpenses
                  .sort((a, b) => {
                    const dateA = new Date(a.date).getTime();
                    const dateB = new Date(b.date).getTime();
                    if (dateB !== dateA) return dateB - dateA;
                    return b.id - a.id;
                  })
                  .map((expense, rowIdx) => (
                    <TableRow
                      key={expense.id}
                      sx={{
                        background: rowIdx % 2 === 0 ? "#fff" : "#fafbff",
                        "&:hover": { background: alpha(BRAND, 0.03) },
                        transition: "background 0.15s",
                      }}
                    >
                      {/* Date */}
                      <TableCell sx={{ fontSize: 12, color: "#475569", whiteSpace: "nowrap" }}>
                        {expense.date}
                      </TableCell>

                      {/* Details */}
                      <TableCell sx={{ fontSize: 12, color: "#334155" }}>
                        <Box display="flex" alignItems="center" gap={0.5}>
                          <span>{expense.description}</span>
                          {expense.file && expense.file.length > 0 && (
                            <Box display="flex" alignItems="center" ml={0.5}>
                              {parseFiles(expense.file).map((file, index) => (
                                <MuiTooltip key={index} title="View file" arrow>
                                  <IconButton
                                    size="small"
                                    onClick={() => handleOpenModal(file)}
                                    sx={{ color: "#64748b", p: 0.3, "&:hover": { color: BRAND } }}
                                  >
                                    <DescriptionIcon sx={{ fontSize: 14 }} />
                                  </IconButton>
                                </MuiTooltip>
                              ))}
                            </Box>
                          )}
                        </Box>
                      </TableCell>

                      {/* Category */}
                      <TableCell sx={{ fontSize: 12, color: "#475569" }}>
                        {categoryMap[expense.category] || "—"}
                      </TableCell>

                      {/* Type */}
                      <TableCell sx={{ fontSize: 12, color: "#475569" }}>
                        {expense.type || "—"}
                      </TableCell>

                      {/* Amount */}
                      <TableCell sx={{ fontSize: 12, color: "#1e293b", fontWeight: 600, whiteSpace: "nowrap" }}>
                        ${Number(expense.amount).toFixed(2)}
                      </TableCell>

                      {/* HST */}
                      <TableCell sx={{ fontSize: 12, color: "#64748b", whiteSpace: "nowrap" }}>
                        ${Number(expense.hst).toFixed(2)}
                      </TableCell>

                      {/* Total */}
                      <TableCell sx={{ fontSize: 12, fontWeight: 700, color: "#0f172a", whiteSpace: "nowrap" }}>
                        ${Number(expense.total).toFixed(2)}
                      </TableCell>

                      {/* Status */}
                      <TableCell>
                        <Chip
                          label={expense.status}
                          size="small"
                          sx={{
                            background: String(expense.status) === "Paid" ? alpha(SUCCESS, 0.12) : alpha(DANGER, 0.1),
                            color: String(expense.status) === "Paid" ? "#15803d" : "#b91c1c",
                            fontWeight: 700,
                            fontSize: 11,
                            border: `1px solid ${String(expense.status) === "Paid" ? alpha(SUCCESS, 0.3) : alpha(DANGER, 0.25)}`,
                          }}
                        />
                      </TableCell>

                      {/* Actions */}
                      <TableCell sx={{ textAlign: "right" }}>
                        <Box display="flex" alignItems="center" justifyContent="flex-end" gap={0.5}>
                          <MuiTooltip title="View images" arrow>
                            <IconButton
                              size="small"
                              onClick={() => {
                                const before = Array.isArray(expense.before_images)
                                  ? expense.before_images
                                  : expense.before_images ? JSON.parse(expense.before_images) : [];
                                const after = Array.isArray(expense.after_images)
                                  ? expense.after_images
                                  : expense.after_images ? JSON.parse(expense.after_images) : [];
                                handleViewImages(before, after);
                              }}
                              sx={{ background: alpha("#3b82f6", 0.08), color: "#3b82f6", borderRadius: 1, p: 0.7, "&:hover": { background: alpha("#3b82f6", 0.16) } }}
                            >
                              <VisibilitySharpIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                          </MuiTooltip>
                          <MuiTooltip title="Edit expense" arrow>
                            <IconButton
                              size="small"
                              onClick={() => handleEditClick(expense.id)}
                              sx={{ background: alpha(BRAND, 0.08), color: BRAND, borderRadius: 1, p: 0.7, "&:hover": { background: alpha(BRAND, 0.16) } }}
                            >
                              <EditSharpIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                          </MuiTooltip>
                          <MuiTooltip title="Delete expense" arrow>
                            <IconButton
                              size="small"
                              onClick={() => { setDeleteTargetId(expense.id); setConfirmDeleteOpen(true); }}
                              sx={{ background: alpha(DANGER, 0.08), color: DANGER, borderRadius: 1, p: 0.7, "&:hover": { background: alpha(DANGER, 0.16) } }}
                            >
                              <DeleteOutlineSharpIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                          </MuiTooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={9} align="center" sx={{ py: 6, color: "#94a3b8", fontSize: 13 }}>
                    No expenses found.
                  </TableCell>
                </TableRow>
              )}

              {/* Footer totals */}
              <TableRow sx={{ background: "#f8fafc" }}>
                <TableCell colSpan={4} align="right" sx={{ fontWeight: 700, fontSize: 12, color: "#475569", borderTop: `2px solid ${BORDER}` }}>
                  Totals
                </TableCell>
                <TableCell sx={{ fontWeight: 800, fontSize: 13, color: "#0f172a", borderTop: `2px solid ${BORDER}`, whiteSpace: "nowrap" }}>
                  ${totalAmount.toFixed(2)}
                </TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: 13, color: "#334155", borderTop: `2px solid ${BORDER}`, whiteSpace: "nowrap" }}>
                  ${totalHst.toFixed(2)}
                </TableCell>
                <TableCell colSpan={3} sx={{ fontWeight: 800, fontSize: 13, color: "#0f172a", borderTop: `2px solid ${BORDER}`, whiteSpace: "nowrap" }}>
                  ${totalAmountWithTax.toFixed(2)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", px: 3, py: 2, borderTop: `1px solid ${BORDER}` }}>
          <Pagination
            count={Math.ceil(filteredExpenses.length / rowsPerPage)}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={handleChangePage}
          />
        </Box>
      </Box>

      {/* ── Image Viewer Dialog ── */}
      <Dialog open={openModalView} onClose={handleCloseModalView} maxWidth="lg" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ fontWeight: 700, fontSize: 15, borderBottom: `1px solid ${BORDER}`, pb: 1.5, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          View Images
          <IconButton edge="end" onClick={handleCloseModalView} sx={{ color: "#64748b" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Box display="flex" flexDirection={{ xs: "column", md: "row" }} gap={3}>
            <Box flex={1}>
              <Typography sx={{ fontWeight: 700, fontSize: 13, color: "#334155", mb: 1.5 }}>Before Images</Typography>
              {beforeImages.length > 0 ? (
                <Box display="flex" flexDirection="column" gap={2}>
                  {beforeImages.map((img, i) => {
                    const url = `${LARAVEL_API_URL}/${img}`;
                    return (
                      <Box key={i} sx={{ borderRadius: 2, overflow: "hidden", border: `1px solid ${BORDER}` }}>
                        {url.endsWith(".pdf") ? (
                          <iframe src={url} style={{ width: "100%", height: 500 }} title="PDF" />
                        ) : (
                          <img src={url} alt="Before" style={{ width: "100%", height: "auto", maxHeight: 500, objectFit: "contain" }} />
                        )}
                      </Box>
                    );
                  })}
                </Box>
              ) : (
                <Typography sx={{ color: "#94a3b8", fontSize: 13 }}>No before images available.</Typography>
              )}
            </Box>
            <Box flex={1}>
              <Typography sx={{ fontWeight: 700, fontSize: 13, color: "#334155", mb: 1.5 }}>After Images</Typography>
              {afterImages.length > 0 ? (
                <Box display="flex" flexDirection="column" gap={2}>
                  {afterImages.map((img, i) => {
                    const url = `${LARAVEL_API_URL}/${img}`;
                    return (
                      <Box key={i} sx={{ borderRadius: 2, overflow: "hidden", border: `1px solid ${BORDER}` }}>
                        {url.endsWith(".pdf") ? (
                          <iframe src={url} style={{ width: "100%", height: 500 }} title="PDF" />
                        ) : (
                          <img src={url} alt="After" style={{ width: "100%", height: "auto", maxHeight: 500, objectFit: "contain" }} />
                        )}
                      </Box>
                    );
                  })}
                </Box>
              ) : (
                <Typography sx={{ color: "#94a3b8", fontSize: 13 }}>No after images available.</Typography>
              )}
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* ── Delete Confirmation Dialog ── */}
      <Dialog open={confirmDeleteOpen} onClose={() => setConfirmDeleteOpen(false)} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ fontWeight: 700, fontSize: 15 }}>Delete Expense</DialogTitle>
        <DialogContent>
          <Typography sx={{ fontSize: 14, color: "#334155" }}>
            Are you sure you want to delete this expense? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <Button onClick={() => setConfirmDeleteOpen(false)} variant="outlined" sx={{ borderRadius: "8px", textTransform: "none" }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              if (deleteTargetId !== null) handleDeleteClick(deleteTargetId);
              setConfirmDeleteOpen(false);
              setDeleteTargetId(null);
            }}
            sx={{ borderRadius: "8px", textTransform: "none", bgcolor: DANGER, "&:hover": { bgcolor: "#dc2626" } }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── File Viewer Dialog ── */}
      <Dialog open={openModal} onClose={handleCloseModal} fullWidth maxWidth="md" PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ fontWeight: 700, fontSize: 15, borderBottom: `1px solid ${BORDER}`, pb: 1.5, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          View File
          <IconButton onClick={handleCloseModal} sx={{ color: "#64748b" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          {isPdf ? (
            <iframe src={fileUrl || ""} style={{ width: "100%", height: 500, border: "none", borderRadius: 8 }} title="PDF Viewer" />
          ) : (
            <img src={fileUrl || ""} alt="File" style={{ width: "100%", height: 500, objectFit: "contain", borderRadius: 8 }} />
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: `1px solid ${BORDER}` }}>
          <Button onClick={handleCloseModal} sx={{ borderRadius: 1.5, fontWeight: 700, textTransform: "none", color: "#64748b", border: `1px solid ${BORDER}`, px: 3 }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
};

export default Index;
